import { MemberBankForm } from './BankForm'
import { MemberBankList } from './BankList'
import { MemberBankProps } from './interface'
import { MemberBankListStoreProvider } from './Store'

export const MemberBank = (props: MemberBankProps) => {
  return (
    <MemberBankListStoreProvider {...props}>
      <MemberBankForm />
      <MemberBankList />
    </MemberBankListStoreProvider>
  )
}
